<template>
  <div class="enrolling-special-approve" v-loading="loading" :element-loading-text="loadingMsg">
    <div class="title">{{rowData.trueName}}</div>
    <div class="body">
      <div class="body-item">
        <div class="label">申请表：</div>
        <div class="item-cont">
          <el-image v-for="(item, index) in specialApplyFormPaths" :src="item" :key="index" fit="contain"
                    :preview-src-list="previewImageList" class="image-item"></el-image>
        </div>
      </div>
      <div class="body-item">
        <div class="label">相关奖励：</div>
        <div class="item-cont">
          <el-image v-for="(item, index) in specialApplyAwardPaths" :src="item" :key="index" fit="contain"
                    :preview-src-list="previewImageList" class="image-item"></el-image>
        </div>
      </div>
      <div class="body-item">
        <div class="label">证明材料：</div>
        <div class="item-cont">
          <el-image v-for="(item, index) in specialApplyEvidencePaths" :src="item" :key="index" fit="contain"
                    :preview-src-list="previewImageList" class="image-item"></el-image>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="body-item">
        <div class="label">{{extraParams.step === 1 ? '初审' : '终审'}}结果：</div>
        <div class="item-cont">
          <el-radio-group v-model="approveCode" @input="changeApproveCode" :disabled="disabled">
            <template v-for="(item, index) in approveList">
              <el-radio class="margin-top" v-if="item && item.code && item.name" :label="item.code" :key="index">{{item.name}}</el-radio>
            </template>
          </el-radio-group>
        </div>
      </div>
      <div class="body-item">
        <div class="label">审核理由：</div>
        <div class="item-cont">
          <el-input type="textarea" :maxlength="200" :disabled="disabled"
                    v-model="specialApproveReason" placeholder="请输入200字符以内审核理由"></el-input>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!disabled">
      <el-button type="primary" @click="saveApproveInfo" :loading="loading">提交审核</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnrollingSpecialApprove',
  props: {
    rowData: Object,
    visible: Boolean,
    extraParams: Object
  },
  data () {
    return {
      loading: false,
      loadingMsg: '数据加载中，请稍等...',
      errorMsg: '',
      specialApplyFormPaths: [],
      specialApplyAwardPaths: [],
      specialApplyEvidencePaths: [],
      specialApproveStatus: '',
      specialApproveReason: '',
      approveList: [
        {
          code: '1',
          name: '审核通过'
        },
        {
          code: '0',
          name: '审核不通过'
        }
      ],
      approveCode: ''
    }
  },
  computed: {
    previewImageList () {
      return this.specialApplyFormPaths.concat(this.specialApplyAwardPaths, this.specialApplyEvidencePaths)
    },
    disabled () {
      if (this.extraParams.step === 1) {
        return this.specialApproveStatus === '4' || this.specialApproveStatus === '5'
      } else {
        return this.specialApproveStatus === '1' || this.specialApproveStatus === '3'
      }
    }
  },
  methods: {
    queryApplyInfo () {
      this.loadingMsg = '数据加载中，请稍等...'
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/special/apply/queryApplyInfo',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.specialApplyFormPaths = response.data['specialApplyFormPaths'] || []
              this.specialApplyAwardPaths = response.data['specialApplyAwardPaths'] || []
              this.specialApplyEvidencePaths = response.data['specialApplyEvidencePaths'] || []
              this.specialApproveStatus = response.data['specialApproveStatus'] || ''
              this.specialApproveReason = response.data['specialApproveReason'] || ''
              if (this.extraParams.step === 1) {
                if (this.specialApproveStatus === '3') {
                  this.approveCode = '0'
                } else if (!this.specialApproveStatus || this.specialApproveStatus === '1') {
                  this.approveCode = ''
                } else {
                  this.approveCode = '1'
                }
              } else {
                if (this.specialApproveStatus === '4') {
                  this.approveCode = '1'
                } else if (this.specialApproveStatus === '5') {
                  this.approveCode = '0'
                } else {
                  this.approveCode = ''
                }
              }
              break
            }
            default: {
              this.errorMsg = response.data['message'] || '查询信息失败'
              break
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    changeApproveCode () {
      this.specialApproveReason = ''
    },
    saveApproveInfo () {
      if (!this.approveCode) {
        this.$message.error('请选择审核结果')
        return
      }
      if (this.approveCode === '0' && !this.specialApproveReason) {
        this.$message.error('审核不通过时，请输入审核理由')
        return
      }
      this.loadingMsg = '数据提交中，请稍等...'
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/special/apply/approveApplyInfo',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.rowData.id,
          step: this.extraParams.step,
          approveCode: this.approveCode,
          approveReason: this.specialApproveReason
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'] || '提交成功')
              this.$emit('hidePopoverAndRefresh')
              break
            }
            default: {
              this.$message.error(response.data['message'] || '提交失败')
              break
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.queryApplyInfo()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.enrolling-special-approve {
  padding: 10px;
  & > .title {
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    text-align: center;
  }
  & > .body {
    display: flex;
    flex-direction: column;
    gap: 10px;
    & > .body-item {
      display: flex;
      & > .label {
        width: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      & > .item-cont {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        width: 100%;
        & > .image-item {
          width: 150px;
          height: 150px;
        }
      }
    }
  }
  & > .footer {
    text-align: center;
    padding: 10px;
  }
}
</style>
